"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedsale = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedsale` : '') + (description ? ` desc-brandedsale` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedsale"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedsale"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58 29a29 29 0 1 1-58 0 29 29 0 0 1 58 0Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0v58a28.7 28.7 0 0 1-20.5-8.5A29.52 29.52 0 0 1 .05 29a28.9 28.9 0 0 1 8.9-20.91C14.72 2.55 21.54-.1 29 0Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M52.64 33.32c0-.62-.5-1.13-1.12-1.13h-5.17v-2.4h4.35a1.1 1.1 0 0 0 1.13-1.1c0-.63-.5-1.13-1.13-1.13h-4.35v-2.32h5.09a1.12 1.12 0 1 0 0-2.24H45.1c-.7 0-1.26.55-1.26 1.25v8.9c0 .7.55 1.26 1.25 1.26h6.41a1.1 1.1 0 0 0 1.13-1.1Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 32.25h-4.65v-7.98c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26 1.26v9c0 .7.55 1.26 1.25 1.26H40c.64 0 1.14-.5 1.14-1.14 0-.63-.5-1.14-1.14-1.14Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m28.04 33.15-3.98-8.99c-.27-.61-.76-1-1.45-1h-.15c-.68 0-1.2.38-1.47 1L17 33.14c-.08.18-.15.36-.15.54 0 .65.5 1.18 1.16 1.18.53 0 .95-.3 1.17-.79l.8-1.87H25l.76 1.8c.23.52.62.87 1.2.87.67 0 1.2-.54 1.2-1.21 0-.17-.06-.33-.14-.51ZM20.9 30l1.58-3.77L24.06 30H20.9Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.96 31.36c0-1.99-1.3-2.82-3.63-3.44-1.98-.5-2.46-.75-2.46-1.5v-.03c0-.56.5-1 1.47-.99.78 0 1.57.28 2.4.76a1.16 1.16 0 0 0 1.82-.97c0-.48-.28-.83-.56-1a6.68 6.68 0 0 0-3.62-1c-2.33 0-4 1.37-4 3.43v.04c0 2.26 1.49 2.9 3.79 3.48 1.9.5 2.3.83 2.3 1.46v.03c0 .67-.62 1.07-1.66 1.07-1.1 0-2.05-.39-2.91-1.03-.16-.1-.4-.23-.72-.23a1.17 1.17 0 0 0-.71 2.11 7.36 7.36 0 0 0 4.3 1.37c2.46 0 4.19-1.27 4.19-3.54v-.03Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedsale;